import { Button, DialogFooter } from "@repo/ui";

type Props = {
  loading: boolean;
  onSave: (e?: React.FormEvent) => void;
  onCancel?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
};

export const TaskDialogFooter = ({ loading, onSave, onCancel, onDelete, disabled }: Props) => (
  <DialogFooter>
    <div className="flex w-full items-center justify-between">
      <div>
        {onDelete && (
          <Button
            type="button"
            variant="ghost"
            onClick={onDelete}
            disabled={loading}
            className="text-red-600 hover:bg-red-50 hover:text-red-700"
          >
            Delete
          </Button>
        )}
      </div>
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button type="submit" onClick={onSave} loading={loading} disabled={disabled || loading}>
          Save
        </Button>
      </div>
    </div>
  </DialogFooter>
);
